import classNames from 'classnames'
import * as React from 'react'

import {getAgentPoolHref} from '../../../../../../routes'
import {toAgentPoolId} from '../../../../../../types'
import RouterLink from '../../../../../common/RouterLink/RouterLink'
import type {AgentPoolProjectsTreeProjectItem} from '../../AgentPoolPage.types'
import {onOverflowingElementMouseEnter} from '../../AgentsTab/AssignAgentsButton/AssignAgentsDialog/AssignAgentsDialog.utils'

import styles from './ProjectPoolsCell.css'

export default function ProjectPoolsCell({
  agentPools,
  agentPoolRawId,
  className,
  actions,
}: AgentPoolProjectsTreeProjectItem & {
  agentPoolRawId: string
  className?: string
  actions: React.ReactNode
}): React.ReactElement | null {
  const otherPools = agentPools
    .filter(pool => pool.rawId !== agentPoolRawId)
    .map(pool => ({
      id: pool.id,
      rawId: pool.rawId,
      name: pool.name,
    }))

  return (
    <div role="gridcell" className={classNames(className, styles.cell)}>
      <div
        className={styles.pools}
        data-overflow-title={
          otherPools.length > 0 ? otherPools.map(pool => pool.name).join(', ') : undefined
        }
        onMouseEnter={onOverflowingElementMouseEnter}
      >
        {otherPools.length > 0
          ? otherPools.map((pool, i) => (
              <React.Fragment key={pool.rawId}>
                {i > 0 ? ', ' : null}
                <RouterLink to={getAgentPoolHref(toAgentPoolId(pool.rawId))}>
                  {pool.name}
                </RouterLink>
              </React.Fragment>
            ))
          : null}
      </div>
      <div className={styles.actions}>{actions}</div>
    </div>
  )
}
